import { twMerge as twMergeOriginal } from "tailwind-merge";

export const twMerge = twMergeOriginal;
